import React from 'react';
import PropTypes from 'prop-types';
import DiscoverCard from '../pages/discover/components/DiscoverCard';

const CARD_TYPE_MAP = {
  course: 'Course',
  program: 'Program',
};

const DiscoverCardRenderer = ({ props: p = {} }) => {
  const {
    link, title, image, variant,
  } = p;
  if (!link) { return null; }
  const type = CARD_TYPE_MAP[(variant || 'course').toLowerCase()] || 'Course';
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="ai-chat-card-link"
    >
      <DiscoverCard
        title={title}
        imageUrl={image}
        type={type}
        skills={[]}
        rating={null}
        reviewCount={0}
        price={0}
      />
    </a>
  );
};

DiscoverCardRenderer.propTypes = {
  props: PropTypes.shape({
    link: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    variant: PropTypes.string,
  }),
};
DiscoverCardRenderer.defaultProps = { props: {} };

export const aiChatRegistry = { DiscoverCard: DiscoverCardRenderer };
